package songwritersnotebook.database

import kotlin.Long
import kotlin.String

public data class WaveformEntity(
  public val url: String,
  public val ownerId: String,
  public val points: String,
  public val durationMillis: Long,
)
